import React, { Component } from "react";

class StatusPublishedSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg" /*d="M3.3,2.6V1.3c0-0.2,0.1-0.3,0.3-0.3h0.9V0.5C4.5,0.2,4.7,0,5,0h4c0.3,0,0.5,0.2,0.5,0.5V1h0.9
	c0.2,0,0.3,0.1,0.3,0.3v1.3c0,0.2-0.1,0.3-0.3,0.3H3.5C3.4,2.9,3.3,2.8,3.3,2.6z M12.7,0.9H12v2.6c0,0.3-0.3,0.5-0.5,0.5H2.6
	c-0.3,0-0.5-0.3-0.5-0.5V0.9H1.3C0.5,0.9,0,1.5,0,2.2v12.5C0,15.5,0.6,16,1.3,16h11.5c0.7,0,1.3-0.6,1.3-1.3V2.2
	C14,1.5,13.4,0.9,12.7,0.9z M7.2,13H6.4L3.9,9.5l0.9-0.8l1.9,2.8l3.3-4.7L11,7.5L7.2,13z"*/
          d="M16,0.6v14.9c0,0.3-0.3,0.6-0.6,0.6H0.6C0.3,16,0,15.8,0,15.5v-3.6c0-3.4,1.9-4.3,3.6-4.4l4.4,0L5.7,5.2
	C5.5,5,5.5,4.6,5.8,4.4c0.2-0.2,0.6-0.2,0.8,0l3.1,3.3c0,0,0,0,0,0C9.8,7.8,9.8,7.9,9.8,8c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3
	c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1l-3.1,3.3C6.5,11.9,6.3,12,6.2,12c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.8L8,8.7
	l-4.4,0c-1.7,0.1-2.5,1.1-2.5,3.3v3h13.8V1.1H1.1v4.5c0,0.3-0.3,0.6-0.6,0.6C0.3,6.2,0,6,0,5.7V0.6C0,0.3,0.3,0,0.6,0h14.9
	C15.7,0,16,0.3,16,0.6z M6.2,11 M7.8,2.2C7.4,2.2,7,2.5,7,3s0.4,0.8,0.8,0.8S8.6,3.4,8.6,3S8.3,2.2,7.8,2.2z M10.4,2.2
	C9.9,2.2,9.6,2.5,9.6,3s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S10.8,2.2,10.4,2.2z M12.9,2.2c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8
	c0.4,0,0.8-0.4,0.8-0.8S13.4,2.2,12.9,2.2z"
        />
      </svg>
    );
  }
}

export default StatusPublishedSVG;



// WEBPACK FOOTER //
// ./src/svg/StatusPublishedSVG.jsx